export const EMAIL_VERIFICATION_MESSAGES = {
  EXPIRED: 'Link expired!',
  INVALID: 'Invalid token!',
  MISSED_TOKEN: 'Email Verification token is missing!',
  UNKNOWN: 'Error occurred during email verification process!',
  TOO_MANY_REQUESTS: 'Too many requests!',
  VERIFIED: 'Email verified!',
};
